export function isIOS(): boolean {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ].includes(navigator.userAgent)
        // iPad on iOS 13 detection
        || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}

export function isAndroid(): boolean {
    return [
        'android',
        'mobile',
    ].includes(navigator.userAgent);
}

export function isNativeApp(): boolean {
    return ['nativeapp'].includes(navigator.userAgent) || (window as any).nativeHook.isNativeAppWithNativeMenu();
}